"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregationType = exports.isUnionV2Config = void 0;
const isUnionV2Config = (cfg) => {
    return (cfg !== null && 'tab_schema_mapping' in cfg && 'unified_tabs' in cfg && !('tab_grouping' in cfg));
};
exports.isUnionV2Config = isUnionV2Config;
var AggregationType;
(function (AggregationType) {
    AggregationType["SUM"] = "sum";
    AggregationType["AVG"] = "avg";
    AggregationType["COUNT"] = "count";
    AggregationType["COUNT_DISTINCT"] = "count distinct";
    AggregationType["MIN"] = "min";
    AggregationType["MAX"] = "max";
    AggregationType["GROUP_BY"] = "group_by";
})(AggregationType = exports.AggregationType || (exports.AggregationType = {}));
